import {merge} from '#core/utils/config-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';
import {generateCloseButton} from '#core/application/modules/tiles/close-button/index.js';

import {Dialogs} from '../dialogs.js';

import PALETTE_SCHEMA from './combination-odds-popup.palette-schema.yaml';

class CombinationOddsPopupFeature extends AbstractVisualFeature {
    get name() {
        return 'CombinationOddsPopup';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getVisualConfig(PALETTE) {
        return {
            CombinationOddsPopup: {
                dialog: {
                    background: resolveBackground(PALETTE.COMBINATION_ODDS_BG),
                    header: {
                        container: {
                            style: {
                                padding: '0 16px',
                            },
                            borderStyle: PALETTE.COMBINATION_ODDS_HEADER_SHOW_SEPARATOR
                                ? {
                                      borderWidth: '0 0 1px 0',
                                      borderStyle: 'solid',
                                      borderColor: PALETTE.COMBINATION_ODDS_DIVIDER_COLOR,
                                  }
                                : {},
                        },
                    },
                    closeButton: merge(generateCloseButton(PALETTE.COMBINATION_ODDS_CLOSE_BUTTON), {
                        button: {
                            style: {
                                base: {
                                    backgroundColor: 'transparent',
                                    boxShadow: 'none',
                                },
                            },
                        },
                    }),
                    closeButtonContainer: {
                        style: {
                            top: 0,
                            bottom: 'initial',
                        },
                    },
                },
                popupHeaderTitle: {
                    style: {
                        ...PALETTE.COMBINATION_ODDS_HEADER_TITLE,
                    },
                },
                contentContainer: {
                    style: {
                        padding: '8px 16px',
                    },
                },
                combinationOddsGrid: {
                    style: {
                        padding: 0,
                    },
                },
                gridHeader: {
                    style: {
                        padding: '0 0 4px 0', // should be moved to container section
                        ...PALETTE.COMBINATION_ODDS_TABLE.TABLE_HEADER_TEXT,
                    },
                },
                gridText: {
                    style: {
                        padding: '8px 0 0 0', // should be moved to container section
                        ...PALETTE.COMBINATION_ODDS_TABLE.TABLE_ITEM_TEXT,
                    },
                },
            },
        };
    }
}

if (FEATURES.virtuals) {
    new CombinationOddsPopupFeature(Dialogs);
}
